<template>
  <form-item-facade
    class="checkbox-item"
    :errors="errors"
    :name="name"
    :rules="rules"
  >
    <checkbox-facade
      v-model="model"
      :disabled="disabled"
      @change="$emit('change')"
    >
      <slot></slot>
    </checkbox-facade>
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import CheckboxFacade from '@/lib/ant-design-vue/components/CheckboxFacade.vue';
  import FormItemFacade from '@/lib/ant-design-vue/components/FormItemFacade.vue';
  
  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Disable checkbox
    disabled: {
      type: Boolean,
      default: false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // Правила валидации поля.
    rules: Object,
  });

  defineEmits(['change']);
</script>

<style lang="scss" scoped>

</style>